import { render, staticRenderFns } from "./img-text-mine-comment.vue?vue&type=template&id=30400c9c&scoped=true&"
import script from "./img-text-mine-comment.vue?vue&type=script&lang=js&"
export * from "./img-text-mine-comment.vue?vue&type=script&lang=js&"
import style0 from "./img-text-mine-comment.vue?vue&type=style&index=0&id=30400c9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30400c9c",
  null
  
)

export default component.exports